<template>
  <v-app>
    <v-main>
      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="d-flex justify-center">
            <v-card class="error-card text-center">

              <div class="d-flex justify-center mb-6">
                <img :src="logo" alt="Maira Logo" class="logo" />
              </div>

              <h1 class="error-code">404</h1>

              <div class="error-title">
                ページが見つかりません
              </div>

              <div class="body-desc">
                {{ errorMessage }}
                <br />
                URLをご確認いただくか、ホームページへお戻りください。
              </div>

              <v-btn color="primary" depressed class="home-btn" to="/">
                <v-icon left>mdi-arrow-left</v-icon>
                ホームに戻る
              </v-btn>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "NotFoundPage",
  props: {
    errorMessage: {
      type: String,
      default: "要求されたURLは存在しません。",
      required: false,
    },
  },
  data() {
    return {
      logo: require("@/assets/images/logo_horizontal.png"),
    };
  },
};
</script>

<style scoped>
.error-card {
  width: 100%;
  max-width: 600px;
  padding: 48px 56px;
  border-radius: 16px !important;

}
.logo {
  max-height: 55px;
  object-fit: contain;
}

.error-code {
  font-size: 110px;
  font-weight: 900;
  line-height: 1;
  color: #435f93;
  margin-bottom: 28px;
}

.error-title {
  font-size: 28px;
  font-weight: 800;
  color: #222;
  margin-bottom: 24px;
  line-height: 1.2;
}

.body-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 32px;
}

.home-btn {
  width: 170px;
  height: 52px !important;
  border-radius: 8px !important;
  font-size: 18px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}
</style>